import { v7 as uuidv7 } from "uuid";
import { z } from "zod";
import { buildingSchema } from "./building";

export const buildingShiftRowSchema = z.object({
  id: z.string().brand("buildingShiftRowId"),
  name: z.string(),
  buildingShiftGroupId: z.string(),
  buildingId: buildingSchema.shape.id,
  shiftNumber: z.number().default(1),
  startHour: z.number(),
  startMinute: z.number(),
  endHour: z.number(),
  endMinute: z.number(),
});

export type BuildingShiftRow = z.infer<typeof buildingShiftRowSchema>;

export type BuildingShiftRowInput = z.input<typeof buildingShiftRowSchema>;

export const newBuildingShiftRow = (input: BuildingShiftRowInput): BuildingShiftRow =>
  buildingShiftRowSchema.parse(input);

export const createBuildingShiftRow = (input: Omit<BuildingShiftRowInput, "id">): BuildingShiftRow =>
  newBuildingShiftRow({ ...input, id: uuidv7() });
